import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  IconButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { formatter } from "../../helper/functions";

const ConfirmPayment = ({ open, handleClose, payoutData, recipientId }) => {
  if (!payoutData) return null;

  const {
    payoutId,
    recipientType,
    userId,
    selectedRows,
    payoutMethod,
    notes,
    evidenceUrl,
    totalAmount,
  } = payoutData;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <Box sx={{ p: 2, position: "relative" }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "grey.500",
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: "bold",
            color: "#673C8E",
          }}
        >
          Paying Pending Payment
        </DialogTitle>

        <DialogContent>
          <Typography
            align="center"
            fontWeight="600"
            color="#673C8E"
            variant="subtitle1"
          >
            Paid for {selectedRows.length}{" "}
            {selectedRows.length > 1 ? "Entries" : "Entry"} To {recipientId} -
            Amount{" "}
            {formatter.format(
              selectedRows.reduce((obj, curr) => obj + curr.amount, 0)
            )}{" "}
            CAD
          </Typography>
          <Typography
            align="center"
            variant="body2"
            mt={1}
            sx={{ color: "black" }}
          >
            Payout ID : {payoutId}
          </Typography>

          <Box
            mt={4}
            sx={{
              display: "flex",
              width: "60%",
            }}
          >
            {/* Titles column */}
            <Box sx={{ width: "50%", pr: 2 }}>
              <Typography variant="body1" fontWeight="600" color="#673C8E">
                Payout Method
              </Typography>
              <Typography
                variant="body1"
                fontWeight="600"
                color="#673C8E"
                mt={1}
              >
                Notes
              </Typography>
              <Typography
                variant="body1"
                fontWeight="600"
                color="#673C8E"
                mt={1}
              >
                Evidence
              </Typography>
            </Box>

            {/* Data column */}
            <Box sx={{ width: "50%" }}>
              <Typography variant="body1" color="black">
                : {payoutMethod || "N/A"}
              </Typography>
              <Typography variant="body1" color="black" mt={1}>
                : {notes ? notes.replace(/<[^>]*>/g, "") : "No notes"}
              </Typography>
              {evidenceUrl ? (
                <Box
                  mt={1}
                  sx={{
                    width: 120,
                    height: 80,
                    borderRadius: 1,
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={evidenceUrl}
                    alt="Evidence"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </Box>
              ) : (
                <Typography variant="body1" color="black" mt={1}>
                  : No evidence provided
                </Typography>
              )}
            </Box>
          </Box>
        </DialogContent>
      </Box>
    </Dialog>
  );
};

export default ConfirmPayment;
